import React, { FunctionComponent, useState } from "react";
import { StandardRadioButtonGroup } from '@components/library/radio_button_group';
import { defaultWatermarkPostion, watermarkPositions } from "./WatermarkPositionTypes";
import classes from './watermark_positions.module.scss';

interface WatermarkPositionsProps {
    onChange: (gravity: string) => void;
    gravity?: string;
    showHeading?: boolean;
}

export const WatermarkPositions: FunctionComponent<WatermarkPositionsProps> = (props) => {
  const { gravity, showHeading = true, onChange } = props;

  const [watermarkPosition, setWatermarkPosition] = useState(gravity || defaultWatermarkPostion);

  return (
    <div className={classes.watermarkPositions}>
      {showHeading && <h4>{bfTranslate('Watermark Position')}</h4>}
      <StandardRadioButtonGroup
        checkedId={watermarkPosition}
        className={classes.radioButtonGroup}
        name="watermark-positions"
        onChange={(e: InputChangeEvent): void => {
          setWatermarkPosition(e.target.value);
          onChange(e.target.value);
        }}
        radioButtons={watermarkPositions}
      />
    </div>
  );
};
